import { createDiscoverySession, getCurrentDiscoverySession } from '@/entities/discovery';
import { initialFilterConditions, useDiscoveryStore } from '../stores/discovery-store';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { useEffect } from 'react';
import { useDiscoveryPromptSubmit } from './use-discovery-prompt-submit';

export const useDiscoverySessionRouting = () => {
  const {
    setViewState,
    setSession,
    pendingAutoSearch,
    setPendingAutoSearch,
    searchRequest,
    resetSession,
  } = useDiscoveryStore();
  const { submitPrompt } = useDiscoveryPromptSubmit();
  const { workspaceId } = useWorkspaceId();

  useEffect(() => {
    let isActive = true;

    async function routeToPendingAutoSearch() {
      const prompt = searchRequest.message;
      setPendingAutoSearch(false);

      const newSession = await resetSession();
      if (!isActive || !newSession) return;

      await submitPrompt(newSession, prompt, initialFilterConditions, 'find_creators');
    }

    async function routeToCurrentSession() {
      try {
        const session = await getCurrentDiscoverySession(workspaceId);
        if (!isActive) return;

        if (!session || !session.session_id) {
          await createDiscoverySession(workspaceId);
          const created = await getCurrentDiscoverySession(workspaceId);
          if (!isActive) return;
          setSession(created);
          setViewState('idle');
        } else {
          setSession(session);
          setViewState(session.current_search_history_id ? 'chat' : 'idle');
        }
      } catch {
        if (!isActive) return;
        setSession(null);
        setViewState('idle');
      }
    }

    if (pendingAutoSearch && searchRequest.message) {
      routeToPendingAutoSearch();
    } else {
      routeToCurrentSession();
    }

    return () => {
      isActive = false;
    };
  // Deliberately only re-run on workspace change: pendingAutoSearch/searchRequest are
  // snapshotted at mount so the auto-search reset and the normal session fetch never race.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceId]);
};
